//Products
export const ADD_TO_CART = "ADD_TO_CART"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"

//Tests
export const ADD_TEST = "ADD_TEST"
export const REMOVE_TEST = "REMOVE_TEST"

export const CLEAR_CART = "CLEAR_CART"